<template>
  <b-modal
    :id="'page-i-calendar-modal_'+block.id"
    title="iCalendar"
    :ok-title="trans('close')"
    ok-only
  >
    <p v-if="!!block">
      <i class="fa fa-light fa-calendar"></i>
      {{ block.text ? block.text : 'calendar' }}    
    </p>
    <p v-if="!!url">
      <div v-if="eventOptions" class="mb-3">
        <b-button
          size="sm"
          variant="link"
          class="px-0 shadow-none"
          @click="show_options = !show_options"
        >
          <i :class="`text-left fa fa-fw fa-${show_options ? 'minus-square' : 'plus-square'}`"></i>
          {{ trans('advanced_options') }}
        </b-button>
        <b-collapse v-model="show_options">
          <small class="d-block text-muted mb-2">
            <i class="fa fa-fw fa-info-circle"></i>
            {{ trans('ical_export_options_about') }}
          </small>
          <div class="mb-3">
            <p>{{ trans('ical_event_export') }}</p>
            <treeselect
              ref="event-sources"
              multiple
              v-model="events"
              :options="eventOptions"
              :placeholder="trans('event_sources')"
            >
              <div slot="option-label" slot-scope="{node}">
                {{ node.raw.label }}
                <span><i class="fas fa-circle fa-sm" :style="'color:'+ node.raw.color"></i></span>
              </div>
            </treeselect>
          </div>
         <div>
          <p>{{ trans('ical_date_range_export') }}</p>
          <date-range-picker
            ref="picker"
            v-model="dateRange"
            opens="left"
          >
            <div slot="input" style="min-width: 350px;">
              <i class="fa fa-fw fa-calendar"></i>
              <span v-if="start && end">{{ start.format('LL') }} - {{ end.format('LL') }}</span>
              <span v-else>{{ trans('select_dates') }}</span>
              <i class="fa fa-fw fa-caret-down"></i>
            </div>
          </date-range-picker>
          <b-button variant="link" @click="clearDates">{{ trans('clear') }}</b-button>
         </div>
         <hr>
        </b-collapse>
      </div>
      <b-form-group>
        <label>
          <i class="fa fa-fw fa-calendar"></i>
          {{ trans('i_calendar') }}
        </label>
        <b-input-group>
          <b-form-input :value="url" size="sm" readonly />
          <b-input-group-append>
            <b-button variant="primary" size="sm" v-clipboard:copy="url" :title="trans('copy_to_clipboard')" v-b-tooltip>
              <i class="fa fa-fw fa-copy"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </p>
    <p v-if="!!url">
      {{ trans('i_calendar_feed_about') }}
    </p>
  </b-modal>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import DateRangePicker from 'vue2-daterange-picker'

  export default {
    props: {
      block: Object,
      organization: Object,
      page: Object,
    },
    components: {
      Treeselect,
      DateRangePicker
    },
    data() {
      return {
        trans: trans,
        show_options: false,
        events: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
    },
    computed: {
      url() {
        let params = '';
        if (this.events.length > 0) {
          let events = this.events.map(e => `events[]=${encodeURIComponent(e)}`).join('&')
          params += `?${events}`
        }
        if (this.start && this.end) {
          let prefix = params == '' ? '?' : '&'
          let dates = `${prefix}start=${this.start.format('YYYY-MM-DD')}&end=${this.end.format('YYYY-MM-DD')}`
          params += dates
        }
        let uuid = this.block.uuid ? this.block.uuid : this.setBlockUuid()
        let url =`${window.location.origin}/org/${this.organization.id}/page/${this.page.upid}/calendar/block/${uuid}${params}`
        return url
      },
      eventOptions() {
        if ((!this.block.meta?.event_sources ||
          this.block.meta?.event_sources.length == 0) &&
          (!this.block.meta?.events ||
          this.block.meta.events.length == 0)
        ) return null
        let events = _.union(this.block.meta.event_sources, this.block.meta.events)
        return _.map(events, e => {
          let prefix = null;
          let color = e.color
          if (!e.type) prefix = 'c'
          return {
            id: prefix + e.id,
            label: e.name || e.title,
            color: color
          }
        })
      },
      start() {
        if (!this.dateRange.startDate) return null
        return moment(this.dateRange.startDate, 'YYYY-MM-DD')
      },
      end() {
        if (!this.dateRange.endDate) return null
        return moment(this.dateRange.endDate, 'YYYY-MM-DD')
      },
    },
    methods: {
      setBlockUuid() {
        axios.post(`/org/${this.organization.id}/page/${this.page.id}/set_uuid/${this.block.id}`)
          .then(response => {
            this.busy = false
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
      },
      clearDates() {
        this.dateRange.startDate = null
        this.dateRange.endDate = null
      }
    },
    mounted() {
      window.pageICalendarModal = this
    },
  }
</script>